<div class="d-flex justify-content-center align-items-center vh-100 d-none">
  <div class="card shadow-lg p-4" style="width: 350px; border-radius: 12px">
    <h4 class="text-center mb-3">Verify Email</h4>

    <form>
      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <input
          type="email"
          id="email"
          class="form-control"
          placeholder="Enter your email"
          [(ngModel)]="emailId"
          [ngModelOptions]="{ standalone: true }"
          (change)="validateEmail($event)"
          maxlength="100"
          onpaste="return false"
        />
      </div>

      <button
        type="submit"
        class="btn btn-primary w-100"
        (click)="verifyEmail()"
      >
        Verify</button
      >&nbsp;&nbsp;
      <button
        class="btn btn-primary w-100"
        [disabled]="!ifLinkExpired"
        (click)="updateVerification()"
      >
        Re-send Verification Link
      </button>
      <!-- <div class="d-flex gap-2">
        <button
          type="submit"
          class="btn btn-primary w-50"
          (click)="verifyEmail()"
        >
          Verify
        </button>
        <button
          class="btn btn-primary w-50"
          [disabled]="!ifLinkExpired"
          (click)="updateVerification()"
        >
          Submit
        </button>
      </div> -->
    </form>
  </div>
</div>

<div
  class="modal fade"
  id="successModal"
  tabindex="-1"
  aria-labelledby="successModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content p-4 text-center">
      <h4 class="fw-bold">Success. Your account is ready to use</h4>
      <p class="mt-2">Please proceed to complete your application</p>

      <button
        type="button"
        class="text-center btn btn-save w-100 mt-3"
        (click)="continueToLogin()"
      >
        Continue
      </button>

      <div class="mt-3 small">
        <a href="#">Account Help</a> | <a href="#">Privacy Policy</a>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="linkExpiredModal"
  tabindex="-1"
  aria-labelledby="successModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content p-4 text-center">
      <h4 class="fw-bold">Link Expired</h4>
      <p class="mt-2">Click here for another link</p>

      <button
        class="text-center btn btn-save w-100 mt-3"
        [disabled]="!ifLinkExpired"
        (click)="updateVerification()"
      >
        Re-send Verification Link
      </button>
      <!-- <div class="mt-3 small">
        <a href="#">Account Help</a> | <a href="#">Privacy Policy</a>
      </div> -->
    </div>
  </div>
</div>
